import Axios from "../BaseAxios";
import { API_COMMON_URL, ROUTER_URL } from "../../constants/urls";
import Keys from "../../constants/keys";
import store from "../../store";
import authToken from "../../common/authToken";
import router from "../../router";

const RapydPaymentApiHelper = {
  createSubscriptionPayment(
    requestParams,
    fnSuccessResponse = null,
    fnFailureResponse = null
  ) {
    Axios.request_POST(
      API_COMMON_URL.membershipSubscriptionCreate,
      requestParams,
      {},
      fnSuccessResponse,
      fnFailureResponse,
      authToken.isCorrectAccessToken()
    );
  },

  getPaymentMethods(fnSuccessResponse = null, fnFailureResponse = null) {
    var requestParams = {
      country_code: "IN",
    };

    Axios.request_POST(
      API_COMMON_URL.rapydPaymentMethodList,
      requestParams,
      {},
      fnSuccessResponse,
      fnFailureResponse,
      false
    );
  },

  getPaymentMethodRequiredFields(
    name,
    fnSuccessResponse = null,
    fnFailureResponse = null
  ) {
    var requestParams = {
      name: name,
    };

    Axios.request_POST(
      API_COMMON_URL.rapydPaymentMethodFields,
      requestParams,
      {},
      fnSuccessResponse,
      fnFailureResponse,
      false
    );
  },

  singleSessionSeriesCheckout() {
    const successHandler = (res) => {
      window.location.replace(res.data.payment_redirect_url);
      console.log(res.data.payment_redirect_url, 1);
    };

    const failureHandler = (res) => {
      store.state.workshop.singleWorkshopBtnLoading = false;
      store.state.workshop.buttonLoading = false;
      console.log(res, 2);
    };

    var requestParams = {};
    requestParams[Keys.SESSION_SERIES_ID] = store.state.payment.sessionSeriesId;
    requestParams[Keys.COUNTRY_CODE] = store.state.mainStore.country;
    requestParams[Keys.SESSIONS] = store.state.payment.sessions;

    requestParams[Keys.SOURCE] = store.state.userUTM.utm_source;
    requestParams[Keys.MEDIUM] = store.state.userUTM.utm_medium;
    requestParams[Keys.CAMPAIGN] = store.state.userUTM.utm_campaign;

    Axios.request_POST(
      API_COMMON_URL.checkout,
      requestParams,
      {},
      successHandler,
      failureHandler
    );
  },
  verifyPayment(token) {
    let successHandler = (res) => {
      console.log(res);
      if (res.data.is_payment_completed) {
        if (res.data.payment_type == "Membership") {
          store.state.membership.userMembership = res.data.data;
          router.push({
            name: ROUTER_URL.publicMembership.children.membershipThankYou.name,
          });
        } else {
          store.state.payment.isPaymentSuccess = true;
          store.state.sessionSeriesDetails.purchased = res.data.data;
          if (res.data.data.status == "On-Demand") {
            router.push({
              name:
                ROUTER_URL.publicSession.children.sessionOnDemandDetails.name,
            });
          } else {
            router.push({
              name: ROUTER_URL.publicSession.children.sessionThankYou.name,
            });
          }
        }
      } else {
        store.state.payment.isPaymentSuccess = false;
        router.push({
          name: ROUTER_URL.paymentFailure.name,
        });
      }
    };

    const failureHandler = (res) => {
      console.log(res);
    };

    var requestParams = {};
    requestParams[Keys.CHECKOUT_TOKEN] = token;

    Axios.request_GET(
      API_COMMON_URL.checkoutVerify,
      requestParams,
      {},
      successHandler,
      failureHandler
    );
  },
  //   verifyPayment(
  //     razorpay_payment_id,
  //     razorpay_order_id,
  //     razorpay_signature,
  //     transaction_id,
  //     fnSuccessResponse = null,
  //     fnFailureResponse = null
  //   ) {
  //     var requestParams = {};
  //     requestParams[Keys.PAYMENT_ID] = razorpay_payment_id;
  //     requestParams[Keys.ORDER_ID] = razorpay_order_id;
  //     requestParams[Keys.PAYMENT_SIGNATURE] = razorpay_signature;
  //     requestParams[Keys.TRANSACTION_ID] = transaction_id;

  //     Axios.request_POST(
  //       API_COMMON_URL.verifyPayment,
  //       requestParams,
  //       {},
  //       fnSuccessResponse,
  //       fnFailureResponse,
  //       false
  //     );
  //   },
};

export default RapydPaymentApiHelper;
